module.exports = __webpack_public_path__ + "img/mv.c7689c57.svg";